import { breakpoints } from '@styles/breakpoints';
import { style } from '@vanilla-extract/css';

const desktop = `screen and (min-width: ${breakpoints.desktop})`;

export const fullPageLayout = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100dvh',
  '@media': {
    [desktop]: { flexDirection: 'row' },
  },
});

export const presentationBlock = style({
  display: 'flex',
  width: '100%',
  '@media': {
    [desktop]: { width: '33.33%' },
  },
});

export const formBlock = style({
  flexGrow: 1,
  width: '100%',
  order: -1,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#f8fcfd !important',
  '@media': {
    [desktop]: { width: '66.67%', order: 0, overflowY: 'scroll' },
  },
});

export const progress = style({
  position: 'sticky',
  top: 0,
  zIndex: 3,
});

export const footerCopyright = style({
  display: 'none',
  fontSize: '0.75rem',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '1.875rem 0.5rem 0.5rem 0.5rem',
  '@media': {
    [desktop]: { display: 'flex' },
  },
});

export const formContainer = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  margin: '0 auto',
  backgroundColor: 'transparent',
  padding: '1rem 0',
  flexGrow: 1,
  '@media': {
    [desktop]: { width: '80%', padding: '1rem' },
  },
});

export const mobileLogo = style({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '0.75rem',
  '@media': {
    [desktop]: { display: 'none' },
  },
});
